module.exports = __webpack_public_path__ + "static/shoe-yellow-1-5cd59b6b507c420ca95a327f6b9e45de.png";